var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NuxtLink',{staticClass:"bk-header__logo max-lg:h-8",attrs:{"to":"/"}},[_c('SfImage',{attrs:{"src":_vm.addBasePath('/logo.svg'),"alt":_vm.$t('Back to Home page'),"width":"32","height":"32"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }